<div fxHide fxShow.gt-md>
    <a *ngIf="model.onClick" [action]="model.onClick">
        <app-contentful-renderer [model]="model.desktopImage"></app-contentful-renderer>
    </a>
    <app-contentful-renderer *ngIf="!model.onClick" [model]="model.desktopImage"></app-contentful-renderer>
</div>
<div fxHide fxShow.md>
    <a *ngIf="model.onClick" [action]="model.onClick">
        <app-contentful-renderer [model]="model.tabletImage"></app-contentful-renderer>
    </a>
    <app-contentful-renderer *ngIf="!model.onClick" [model]="model.tabletImage"></app-contentful-renderer>
</div>
<div fxHide fxShow.lt-md>
    <a *ngIf="model.onClick" [action]="model.onClick">
        <app-contentful-renderer [model]="model.mobileImage"></app-contentful-renderer>
    </a>
    <app-contentful-renderer *ngIf="!model.onClick" [model]="model.mobileImage"></app-contentful-renderer>
</div>
